import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { PinFrequencyDocumentType } from "@/Common/Models/UI/Enums";
import { SendMedicalNoteFormStrategy } from "@/Patient/Services/Portal/Strategies/SendMedicalNoteFormStrategy";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class MedicalNoteFormSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("FormLabel");
    }

    public getItemIconClass(): string {
        return "requestIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(portalPopupModel: PortalPopupModel, onSignatureAccepted: () => void): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return new SendMedicalNoteFormStrategy(portalPopupModel, () => onSignatureAccepted());
    }

    public getPinFrequencyToken(loginPinFrequencyModel: LoginPinFrequencyModel): string {
        return loginPinFrequencyModel?.formToken ?? "";
    }

    public getPinFrequencyDocumentType(): PinFrequencyDocumentType | null {
        return PinFrequencyDocumentType.Form;
    }
}

export { MedicalNoteFormSharedItemProvider };
